const DIFFERENCE = {
  name: "Difference",
  createExpression: (metrics) => {
    return metrics.map((it) => it.alias).join(" - ");
  },
};

const PERCENTAGE = {
  name: "Percentage",
  createExpression: (metrics) => {
    const metricCount = metrics.length;

    if (metricCount < 1) return "0";

    const denominator = metricCount < 2 ? "100" : metrics[1].alias;
    return `(${metrics[0].alias} / ${denominator}) * 100`;
  },
};

const SUM = {
  name: "Sum",
  createExpression: (metrics) => {
    return metrics.map((it) => it.alias).join(" + ");
  },
};

const TIME_SHIFT = {
  name: "Time Shift",
  createExpression: (metrics) => {
    const metricCount = metrics.length;

    if (metricCount < 1) return "0";

    return `TIME_SHIFT(${metrics[0].alias}, -1, DAY)`;
  },
};

const OPERATIONS = [DIFFERENCE, PERCENTAGE, SUM, TIME_SHIFT];

export const getOperations = () => {
  return OPERATIONS.map((it) => it.name);
};

export const getOperation = (name) => {
  return OPERATIONS.find((it) => it.name === name);
};
